import { useEffect, useState } from 'react';
import { useGetDeckblattPDFMutation } from '../../api/AuftragAPI';
import DialogPdfComponent from '../DialogPdfComponent/DialogPdfComponent';

interface ThisProps {
//  uidAuftrag: string;
}

/**
 * @author noone
 */
const AnleitungDownloadButtonComponent: React.FC<ThisProps> = ({  }) => {

   const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/anleitung_auftragseingabe.pdf"; // Pfad zur PDF im public-Ordner
    link.download = "anleitung_auftragseingabe.pdf";     // gewünschter Dateiname
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>

      <button className="btn btn-secondary" onClick={handleDownload}>
            <i className="bi bi-download"></i> Anleitung als PDF
          </button>
    </>
  );

}

export default AnleitungDownloadButtonComponent;